import React from 'react';

import { Storage } from './utils/storage';

export const STORAGE_NAME = 'gogame-storage';

export interface IContext {
  connection: null | Storage;
}

export interface IStorageProvider {
  children: React.ReactNode;
}
